/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeDemolishConfigCreatedResponse,
  ApiEnvelopeDemolishConfigListResponse,
  ApiEnvelopeDemolishEmptyResponse,
  ApiEnvelopeDemolishRunResponse,
  DemolishConfigInputDto,
  DemolishStopDemolishParams,
  RunDemolishRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type demolishGetDemolishConfigsResponse200 = {
  data: ApiEnvelopeDemolishConfigListResponse
  status: 200
}

export type demolishGetDemolishConfigsResponseSuccess = (demolishGetDemolishConfigsResponse200) & {
  headers: Headers;
};
;

export type demolishGetDemolishConfigsResponse = (demolishGetDemolishConfigsResponseSuccess)

export const getDemolishGetDemolishConfigsUrl = () => {




  return `/api/Demolish`
}

export const useDemolishGetDemolishConfigsHook = (): ( options?: RequestInit) => Promise<demolishGetDemolishConfigsResponse> => {

      const customFetcher = useSfetchMutator();
      return ( options?: RequestInit) => {

        return customFetcher(getDemolishGetDemolishConfigsUrl(),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type demolishCreateDemolishConfigResponse200 = {
  data: ApiEnvelopeDemolishConfigCreatedResponse
  status: 200
}

export type demolishCreateDemolishConfigResponseSuccess = (demolishCreateDemolishConfigResponse200) & {
  headers: Headers;
};
;

export type demolishCreateDemolishConfigResponse = (demolishCreateDemolishConfigResponseSuccess)

export const getDemolishCreateDemolishConfigUrl = () => {




  return `/api/Demolish`
}

export const useDemolishCreateDemolishConfigHook = (): (demolishConfigInputDto?: DemolishConfigInputDto, options?: RequestInit) => Promise<demolishCreateDemolishConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (demolishConfigInputDto?: DemolishConfigInputDto, options?: RequestInit) => {

        return customFetcher(getDemolishCreateDemolishConfigUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(demolishConfigInputDto)
  }
);
      }
  }


export type demolishUpdateDemolishConfigResponse200 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 200
}

export type demolishUpdateDemolishConfigResponse404 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 404
}

export type demolishUpdateDemolishConfigResponseSuccess = (demolishUpdateDemolishConfigResponse200) & {
  headers: Headers;
};
export type demolishUpdateDemolishConfigResponseError = (demolishUpdateDemolishConfigResponse404) & {
  headers: Headers;
};

export type demolishUpdateDemolishConfigResponse = (demolishUpdateDemolishConfigResponseSuccess | demolishUpdateDemolishConfigResponseError)

export const getDemolishUpdateDemolishConfigUrl = (id: string,) => {




  return `/api/Demolish/${id}`
}

export const useDemolishUpdateDemolishConfigHook = (): (id: string,
    demolishConfigInputDto?: DemolishConfigInputDto, options?: RequestInit) => Promise<demolishUpdateDemolishConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    demolishConfigInputDto?: DemolishConfigInputDto, options?: RequestInit) => {

        return customFetcher(getDemolishUpdateDemolishConfigUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(demolishConfigInputDto)
  }
);
      }
  }


export type demolishDeleteDemolishConfigResponse200 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 200
}

export type demolishDeleteDemolishConfigResponse404 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 404
}

export type demolishDeleteDemolishConfigResponseSuccess = (demolishDeleteDemolishConfigResponse200) & {
  headers: Headers;
};
export type demolishDeleteDemolishConfigResponseError = (demolishDeleteDemolishConfigResponse404) & {
  headers: Headers;
};

export type demolishDeleteDemolishConfigResponse = (demolishDeleteDemolishConfigResponseSuccess | demolishDeleteDemolishConfigResponseError)

export const getDemolishDeleteDemolishConfigUrl = (id: string,) => {




  return `/api/Demolish/${id}`
}

export const useDemolishDeleteDemolishConfigHook = (): (id: string, options?: RequestInit) => Promise<demolishDeleteDemolishConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string, options?: RequestInit) => {

        return customFetcher(getDemolishDeleteDemolishConfigUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


export type demolishRunDemolishConfigResponse200 = {
  data: ApiEnvelopeDemolishRunResponse
  status: 200
}

export type demolishRunDemolishConfigResponse400 = {
  data: ApiEnvelopeDemolishRunResponse
  status: 400
}

export type demolishRunDemolishConfigResponse404 = {
  data: ApiEnvelopeDemolishRunResponse
  status: 404
}

export type demolishRunDemolishConfigResponseSuccess = (demolishRunDemolishConfigResponse200) & {
  headers: Headers;
};
export type demolishRunDemolishConfigResponseError = (demolishRunDemolishConfigResponse400 | demolishRunDemolishConfigResponse404) & {
  headers: Headers;
};

export type demolishRunDemolishConfigResponse = (demolishRunDemolishConfigResponseSuccess | demolishRunDemolishConfigResponseError)

export const getDemolishRunDemolishConfigUrl = (id: string,) => {




  return `/api/Demolish/${id}/run`
}

export const useDemolishRunDemolishConfigHook = (): (id: string,
    runDemolishRequest?: RunDemolishRequest, options?: RequestInit) => Promise<demolishRunDemolishConfigResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    runDemolishRequest?: RunDemolishRequest, options?: RequestInit) => {

        return customFetcher(getDemolishRunDemolishConfigUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(runDemolishRequest)
  }
);
      }
  }


export type demolishStopDemolishResponse200 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 200
}

export type demolishStopDemolishResponse404 = {
  data: ApiEnvelopeDemolishEmptyResponse
  status: 404
}

export type demolishStopDemolishResponseSuccess = (demolishStopDemolishResponse200) & {
  headers: Headers;
};
export type demolishStopDemolishResponseError = (demolishStopDemolishResponse404) & {
  headers: Headers;
};

export type demolishStopDemolishResponse = (demolishStopDemolishResponseSuccess | demolishStopDemolishResponseError)

export const getDemolishStopDemolishUrl = (id: string,
    params?: DemolishStopDemolishParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Demolish/${id}/stop?${stringifiedParams}` : `/api/Demolish/${id}/stop`
}

export const useDemolishStopDemolishHook = (): (id: string,
    params?: DemolishStopDemolishParams, options?: RequestInit) => Promise<demolishStopDemolishResponse> => {

      const customFetcher = useSfetchMutator();
      return (id: string,
    params?: DemolishStopDemolishParams, options?: RequestInit) => {

        return customFetcher(getDemolishStopDemolishUrl(id,params),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


